import vtkArcSource from './ArcSource';
import vtkArrowSource from './ArrowSource';
import vtkCircleSource from './CircleSource';
import vtkConcentricCylinderSource from './ConcentricCylinderSource';
import vtkConeSource from './ConeSource';
import vtkCubeSource from './CubeSource';
import vtkCursor3D from './Cursor3D';
import vtkCylinderSource from './CylinderSource';
import vtkDiskSource from './DiskSource';
import vtkEllipseArcSource from './EllipseArcSource';
import vtkImageGridSource from './ImageGridSource';
import vtkLineSource from './LineSource';
import vtkPlaneSource from './PlaneSource';
import vtkPlatonicSolidSource from './PlatonicSolidSource';
import vtkPointSource from './PointSource';
import vtkRegularPolygonSource from './RegularPolygonSource';
import vtkRTAnalyticSource from './RTAnalyticSource';
import vtkSLICSource from './SLICSource';
import vtkSphereSource from './SphereSource';
import vtkTorusSource from './TorusSource';

export default {
  vtkArcSource,
  vtkArrowSource,
  vtkCircleSource,
  vtkConcentricCylinderSource,
  vtkConeSource,
  vtkCubeSource,
  vtkCursor3D,
  vtkCylinderSource,
  vtkDiskSource,
  vtkEllipseArcSource,
  vtkImageGridSource,
  vtkLineSource,
  vtkPlaneSource,
  vtkPlatonicSolidSource,
  vtkPointSource,
  vtkRegularPolygonSource,
  vtkRTAnalyticSource,
  vtkSLICSource,
  vtkSphereSource,
  vtkTorusSource,
};
